import { getFeatureToggleClient } from 'infra/featureToggles'

/**
 * Whether the documents domain should use the v5 Documents API.
 */
export default function isDocumentsApiV5Enabled(): boolean {
  return getFeatureToggleClient().variation(
    'WorkPortal.UseDocumentsApiV5',
    false,
  )
}
